<template>
    <div id="rmsDocumentAssignModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="searchTitle" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Link RMS Document</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>                        
                </div>
                <div class="modal-body">
                    <div v-if="document" class="table table-sm table-borderless">                       
                        <tr>
                            <td class="font-weight-bold">Patient Name:</td>
                            <td>{{ document.patient_name }}</td>
                            <td class="font-weight-bold">RMS Document Type:</td>
                            <td>{{ document.rms_document_type.name }}</td>                            
                        </tr>
                        <tr>
                            <td class="font-weight-bold">PAN:</td>
                            <td>{{ document.pan }}</td>
                            <td class="font-weight-bold">DOS:</td>
                            <td>{{ document.dos }}</td>
                        </tr>                                            
                        <tr>
                            <td class="font-weight-bold">Payer Name:</td>
                            <td>{{ document.rms_payer_name }}</td>
                            <td class="font-weight-bold">Claim Number:</td>
                            <td>{{ document.claim_number }}</td>                             
                        </tr>
                        <tr>                             
                            <td class="font-weight-bold">Amount:</td>
                            <td>{{ document.rms_document_total }}</td>
                            <td class="font-weight-bold">Imported:</td>
                            <td>{{ document.created_at }}</td>                            
                        </tr>
                        <tr><td colspan="4">&nbsp;</td></tr>                       
                        <tr>
                            <td class="font-weight-bold">Description:</td>
                            <td colspan="3"><input type="text" class="form-control form-control-sm" v-model="description" /></td>
                        </tr>
                        <tr>
                            <td class="font-weight-bold">Document Type:</td>
                            <td style="padding-top: 3px !important;">
                                <select class="custom-select custom-select-sm" v-model="documentTypeId">
                                    <option v-for="type in documentTypes" :key="'document-type-option-' + type.id" :value="type.id" v-text="type.name"></option>
                                </select>
                            </td>
                            <td></td>
                            <td></td>
                        </tr>                                              
                    </div>

                    <div class="container border-top">
                        <div class="my-2">
                            <div class="text-muted">Select a client.</div>
                            <select  class="custom-select custom-select-sm" v-model="clientId" @change="selectClient(clientId)">
                                <option v-for="client in clients" :key="'search-client-' + client.id" :value="client.id" v-text="client.name"></option>
                            </select>
                        </div>                     
                        <div class="row">                            
                            <div class="col">
                                <div class="text-muted mb-2">Select a claim.</div>                                                             
                                <div class="input-group input-group-sm mb-1">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text p-0">
                                            <i class="fas fa-search fa-lg text-muted ml-2 mr-1"></i>                                          
                                            <select  class="custom-select custom-select-sm-alt border-0" v-model="searchOption1" :disabled="clientId === null">
                                                <option v-for="option in searchOptions1" :key="'search-claim-option-' + option.value" :value="option.value" v-text="option.text"></option>
                                            </select>
                                        </div>
                                    </div>
                                    <input type="text" class="form-control" placeholder="Search Claims" v-model="searchString1" :disabled="clientId === null">
                                </div>                                                              
                                <div v-if="filteredClaims && filteredClaims.length" class="list-group list-group-scroll">
                                    <template v-for="c in filteredClaims">
                                        <button type="button" :class="['list-group-item list-group-item-action', { 'active': claim == c }]" :key="'rms-doc-assign-claim-' + c.claim_id" @click="selectClaim(c)">
                                            <div style="line-height: 1">{{ c.patient_name }}</div>
                                            <div style="line-height: 1"><small>Payer Name: {{ c.payer_name }}</small></div>
                                            <div style="line-height: 1"><small>Claim Number: {{ c.claim_number }}</small></div>
                                            <div style="line-height: 1"><small>Injury Date: {{ c.injury_date }} </small></div>
                                            <div style="line-height: 1"><small>Client: {{ c.client_name }}</small></div>
                                            <div style="line-height: 1"><small>Provider: {{ c.rendering_provider_name }}</small></div>                     
                                        </button>
                                    </template>
                                </div>
                                <div v-else-if="isLoading" class="text-center mt-3">
                                    <span class="text-muted"><i class="fas fa-spinner fa-lg fa-spin align-middle"></i> Loading...</span>
                                </div>
                                <div v-else>
                                    <span class="text-muted">No claims available.</span>
                                </div>
                            </div>
                            <div class="col">
                                <div class="text-muted mb-2">Select a service document.</div>
                                <div class="input-group input-group-sm mb-1">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text p-0">
                                            <i class="fas fa-search fa-lg text-muted ml-2 mr-1"></i>                                          
                                            <select  class="custom-select custom-select-sm-alt border-0" v-model="searchOption2" :disabled="claim === null">
                                                <option v-for="option in searchOptions2" :key="'search-doc-option-' + option.value" :value="option.value" v-text="option.text"></option>
                                            </select>
                                        </div>
                                    </div>
                                    <input type="text" class="form-control" placeholder="Search Service Documents" v-model="searchString2" :disabled="claim === null">
                                </div>                                
                                <div v-if="filteredServiceForms && filteredServiceForms.length" class="list-group list-group-scroll">
                                    <template v-for="s in filteredServiceForms">
                                        <button type="button" :class="['list-group-item list-group-item-action', { 'active': serviceForm == s }]" :key="'rms-doc-assign-doc-' + s.service_form_id" @click="serviceForm = s">
                                            <div style="line-height: 1">{{ s.description }}</div>
                                            <div style="line-height: 1"><small>PAN: {{ s.pan}}</small></div>
                                            <div style="line-height: 1"><small>DOS: {{ s.dos }}</small></div>
                                            <div style="line-height: 1"><small>Submitted At: {{ s.submitted_at }}</small></div>
                                            <div style="line-height: 1"><small>Estimated Reimbursement: {{ s.estimated_reimbursement | currency }}</small></div>
                                            <div style="line-height: 1"><small>Payments: {{ s.total_payments | currency }}</small></div>
                                            <div style="line-height: 1"><small>Payment Date: {{ s.paid_date }}</small></div>                                                              
                                            <div style="line-height: 1"><small>Created: {{ s.created_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</small></div> 
                                        </button>
                                    </template>
                                </div>
                                <div v-else-if="isLoadingDocuments" class="text-center mt-3">
                                    <span class="text-muted"><i class="fas fa-spinner fa-lg fa-spin align-middle"></i> Loading...</span>
                                </div>                                
                                <div v-else>
                                    <span class="text-muted">No service documents available.</span>
                                </div>
                            </div>
                        </div>        
                    </div>                                   
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary" @click="assign()">Assign</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                </div>                                     
            </div>
        </div>
    </div>        
</template>

<script>
export default {
    props: {
        refresh: Function
    },    
    data() {
        return {

            // rms iif document
            document: null,

            documentTypes: [],

            clients: [],
            clientId: null,            
            claims: [],
            claim: null,
            serviceForms: [],
            serviceForm: null,            

            searchOption1: 'patient_name',
            searchString1: '',
            searchOption2: 'pan',
            searchString2: '',

            description: null,
            documentTypeId: null,

            isLoading: false,
            isLoadingDocuments: false,

            searchOptions1: [
                { value: 'patient_name', text: 'Patient Name' },
                { value: 'payer_name', text: 'Payer Name' },
                { value: 'claim_number', text: 'Claim Number' },
                { value: 'client_name', text: 'Client' },
                { value: 'rendering_provider_name', text: 'Provider' }
            ],

            searchOptions2: [
                { value: 'description', text: 'Description' },
                { value: 'pan', text: 'PAN' },
                { value: 'dos', text: 'DOS' },
                { value: 'estimated_reimbursement', text: 'Reimbursement' },
                { value: 'total_payments', text: 'Payments' },
                { value: 'paid_date', text: 'Payment Date' }
            ]
        }
    },
    computed:{
        filteredClaims: function () {
            var self = this;

            // TODO: do we need to worry about compiled javascript changing object property names? shouldn't because these objects
            //       are coming from server side at runtime
            return self.claims.filter(function(claim) {
                return (claim[self.searchOption1] && claim[self.searchOption1].toLowerCase().indexOf(self.searchString1.toLowerCase()) !== -1);
            });         
        },
        filteredServiceForms: function () {
            var self = this;

            return self.serviceForms.filter(function(doc) {
                return (doc[self.searchOption2] && doc[self.searchOption2].toString().toLowerCase().indexOf(self.searchString2.toLowerCase()) !== -1)
            });
        }
    },
    methods: {
        show: function (id) {

            this.document = null;

            // reset component data
            this.clients = [];
            this.clientId = null;            
            this.claims = [];
            this.claim = null;                 
            this.serviceForms = []; 
            this.serviceForm = null;                

            this.searchOption1 = 'patient_name',
            this.searchString1 = '',
            this.searchOption2 = 'pan',
            this.searchString2 = '',

            this.description = null;
            this.documentTypeId = null;        

            axios.get('/ajax/rms/clients/' + id)
                .then(response => {
                    this.document = response.data.document;
                    this.description = this.document.description;
                    this.documentTypeId = this.document.rms_document_type.document_type_id;
                    this.documentTypes = response.data.document_types;
                    this.clients = response.data.clients;

                    $('#rmsDocumentAssignModal').modal('show');
                    
                    if (this.clients && (this.clients.length === 1)) {
                        this.selectClient(this.clients[0].id);
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        selectClient: function (id) {

            this.clientId = id;
            this.claims = [];
            this.claim = null;
            this.serviceForms = [];
            this.serviceForm = null;

            this.isLoading = true;
            axios.get(`/ajax/rms/clients/${this.clientId}/claims`)
                .then(response => {
                    this.claims = response.data.claims;
                    this.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    this.isLoading = false;
                });
        },
        selectClaim: function (claim) {
            this.claim = claim;
            this.serviceForms = [];
            this.serviceForm = null;

            this.isLoadingDocuments  = true;
            axios.get(`/ajax/rms/clients/${this.clientId}/claims/${this.claim.claim_id}/services`)
                .then(response => {
                    this.serviceForms = response.data.documents;
                    this.isLoadingDocuments = false;
                })
                .catch(error => {
                    this.isLoadingDocuments = false;
                })
        },
        assign: function () {

            var self = this;

            axios.patch('/ajax/rms/documents/' + self.document.id, {
                claim_id: self.claim ? self.claim.claim_id : null,
                service_form_id: self.serviceForm ? self.serviceForm.service_form_id : null,
                description: self.description,
                document_type_id: self.documentTypeId
            })
            .then(response => {
                self.refresh();
                $('#rmsDocumentAssignModal').modal('hide');
            })
            .catch(error => {
                console.log(error);
                $('#rmsDocumentAssignModal').modal('hide');
            });
        }
    },
    created() {        
        eventHub.$on('show-rms-document-assign', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-rms-document-assign');
    }
}
</script>

<style scoped>
    td {
        padding-top: 0 !important;
        padding-bottom: 0 !important;       
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }

    .custom-select-sm-alt {
        background-color: #e9ecef;
        padding-top: 0;
        padding-left: 0;
        padding-bottom: 0;
          height: calc(1.5em + 2px);     
    }

    .list-group-scroll {
        max-height: 500px; 
        overflow: scroll; 
        -webkit-overflow-scrolling: touch;
    }    
</style>